var $0c4209a7da92851c$exports = {};
$0c4209a7da92851c$exports = {
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};


export {$0c4209a7da92851c$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
